import type { ContentHierarchyNode, ContentHierarchyResponse } from '@/api/admin'
import type { QuizGroupAssociation } from '@/types/quizSet'

export interface LessonAssociationRow {
  course: ContentHierarchyNode
  module: ContentHierarchyNode
  lesson: ContentHierarchyNode
  association: QuizGroupAssociation
}

export interface QuizItemTypeCounts {
  Q: number
  S: number
  QQS: number
  other: number
}

export function getCurriculumLessonIds(hierarchy?: ContentHierarchyResponse): Set<number> {
  const lessonIds = new Set<number>()
  if (!hierarchy) return lessonIds

  for (const course of hierarchy.children) {
    for (const module of course.children) {
      for (const lesson of module.children) {
        if (lesson.type === 'lesson') lessonIds.add(lesson.id)
      }
    }
  }
  return lessonIds
}

export function buildLessonAssociationRows(
  hierarchy: ContentHierarchyResponse | undefined,
  associations: QuizGroupAssociation[],
): LessonAssociationRow[] {
  if (!hierarchy) return []

  const associationsByLesson = new Map<number, QuizGroupAssociation[]>()
  for (const association of associations) {
    const current = associationsByLesson.get(association.contentId)
    if (current) current.push(association)
    else associationsByLesson.set(association.contentId, [association])
  }

  const rows: LessonAssociationRow[] = []
  for (const course of hierarchy.children) {
    if (course.type !== 'course') continue
    for (const module of course.children) {
      if (module.type !== 'module') continue
      for (const lesson of module.children) {
        if (lesson.type !== 'lesson') continue
        for (const association of associationsByLesson.get(lesson.id) ?? []) {
          rows.push({ course, module, lesson, association })
        }
      }
    }
  }
  return rows
}

export function countQuizItemTypes(association: QuizGroupAssociation): QuizItemTypeCounts {
  const counts: QuizItemTypeCounts = { Q: 0, S: 0, QQS: 0, other: 0 }
  for (const item of association.group.items) {
    const type = item.type.trim().toUpperCase()
    if (type === 'Q' || type === 'S' || type === 'QQS') counts[type] += 1
    else counts.other += 1
  }
  return counts
}
